var React = require('react');
var ReactDOM = require('react-dom');
var $ = require('jquery');
var Loading = require('patternity/lib/loading');
var cn = require('classnames');

var widthAspectRatio = 9 / 16;

const ImagePlaceholder = () =>
  <svg focusable="false" viewBox="0 0 24 24" style={{width: 72}}>
    <g fill="#B0D3F7">
      <path d="M7 13h3a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-7ZM14 13h3v7a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1Z"></path>
      <path d="m3.853 9.154 3.89 3.89-.708.706-3.889-3.889a.5.5 0 0 1 0-.707.5.5 0 0 1 .707 0ZM20.858 9.85l-3.889 3.89-.707-.707 3.889-3.89a.5.5 0 0 1 .707 0 .5.5 0 0 1 0 .708Z"></path>
      <rect x="11.5" y="8" width="1" height="4" rx=".5"></rect>
      <path d="m12 6.16 1.13.69a.12.12 0 0 0 .17-.12L13 5.44l1-.86a.11.11 0 0 0-.06-.19l-1.31-.11-.52-1.21a.11.11 0 0 0-.2 0l-.51 1.21-1.31.11a.11.11 0 0 0-.07.19l1 .86-.3 1.29a.11.11 0 0 0 .17.12ZM8.93 7.09l-.11.06-.35.14-.33.15-.46.18-.19.44-.14.34-.15.36v.12a.12.12 0 0 1-.21 0l-.05-.12-.16-.36-.14-.34-.19-.44-.43-.18-.36-.16-.35-.14-.11-.06a.1.1 0 0 1 0-.2l.11-.06.35-.14.33-.15.46-.18.2-.46.14-.33.15-.35.05-.12a.12.12 0 0 1 .21 0v.12l.16.35.14.33.19.46.46.18.33.15.35.14.11.06a.1.1 0 0 1-.01.21ZM18.93 7.09l-.11.06-.35.14-.33.15-.46.18-.19.44-.14.34-.15.36-.05.12a.12.12 0 0 1-.21 0v-.12l-.16-.36-.14-.34-.19-.44-.43-.18-.36-.16-.35-.14-.11-.06a.1.1 0 0 1 0-.2l.11-.06.35-.14.33-.15.46-.18.2-.46.14-.33.15-.35v-.12a.12.12 0 0 1 .21 0v.12l.16.35.14.33.19.46.46.18.33.15.35.14.11.06a.1.1 0 0 1 .04.21ZM9 12a.5.5 0 0 1-.56-.44c-.07-.73-.16-1.45-.3-2.17a.52.52 0 0 1 .43-.57.5.5 0 0 1 .56.44v.17c.11.59.19 1.19.25 1.79v.24A.52.52 0 0 1 9 12ZM14.89 12a.5.5 0 0 0 .56-.43 20 20 0 0 1 .3-2.18.5.5 0 0 0-.43-.57.5.5 0 0 0-.56.43v.17a15.58 15.58 0 0 0-.25 1.8v.23a.5.5 0 0 0 .38.55Z"></path>
    </g>
  </svg>;

var ChallengeCardImage = React.createClass({
  displayName: "ChallengeCardImage",

  propTypes : {
    image : React.PropTypes.string,
    onChangeCallback: React.PropTypes.func,
    rewriteLook: React.PropTypes.bool
  },

  shouldComponentUpdate: function(nextProps, nextState) {
    return this.state.image !== nextState.image || this.state.isLoading !== nextState.isLoading;
  },

  getDefaultProps : function(){
    return {
      image : null,
      onChangeCallback: function(){}
    };
  },

  getInitialState : function () {
    return {
      image : this.props.image,
      isLoading : true
    };
  },

  componentWillReceiveProps : function (nextProps) {
    this.setState({
      image : nextProps.image,
      isLoading : nextProps.image !== this.props.image || this.state.isLoading
    });
  },

  componentDidMount : function () {
    this._addImageLoadEvent();
    this._addWindowResizeEvent();
  },

  componentDidUpdate : function(){
    this._adjustImageContainerHeight();
  },

  componentWillUnmount: function(){
    this._removeWindowResizeEvent();
  },

  render : function(){
    return (
      <div className={cn({
          "challenge-image card__image": true,
          "no-image": !this.props.image && !this.props.rewriteLook,
          "challenge-image__rewrite": this.props.rewriteLook
        })}
        ref="imageContainer">
        {this.props.rewriteLook && !this.props.image
          ? <ImagePlaceholder />
          : null}
        {!this.props.rewriteLook
          ? this._showLoading()
          : null}
        <img ref="image" style={this._getImageStyle()} src={this.state.image} alt="" />
      </div>
    );
  },

  _getImageStyle: function() {
    if (this.state.isLoading){
      return {display: 'none'}
    }
    return {};
  },

  _showLoading : function(){
    if(!this.state.isLoading) {
      return null;
    }

    return <Loading />
  },

  _addImageLoadEvent : function(){
    var image = ReactDOM.findDOMNode(this.refs.image);
    var self = this;
    image.onload = function(event) {
      self._optimizeImageVisibility(event.target);
    };
  },

  _optimizeImageVisibility : function (image) {
    this._hideLoading();

    if(image.naturalWidth > image.naturalHeight){
      this._optomizeForWidth(image);
    } else {
      this._optimizeForHeight(image);
    }

    if(this._isImageHeightOutOfContainer(image)){
      this._optimizeForHeight(image);
    }

    this._adjustImageContainerHeight();
    this.props.onChangeCallback();
  },

  _isImageHeightOutOfContainer: function(image){
    if (!this.refs.imageContainer) return false;

    var imagePos = image.getBoundingClientRect();
    var imageContainerPos = ReactDOM.findDOMNode(this.refs.imageContainer).getBoundingClientRect();

    return imagePos.bottom > imageContainerPos.bottom;
  },

  _hideLoading : function () {
    this.setState({
      isLoading :  false
    });
  },

  _optomizeForWidth: function(image){
    this._updateImageStyling(image, '100%', 'auto', 'middle');
  },

  _optimizeForHeight: function(image){
    this._updateImageStyling(image, '100%', '100%', 'top');
  },

  _updateImageStyling : function (image, width, height, verticalAlign) {
    image.style.objectFit = 'cover';
    image.style.height = height;
    image.style.verticalAlign = verticalAlign;
    this._updateWidth(image, width);
    $(image).addClass('loaded');
  },

  _updateWidth : function (image, width) {
    if(this._imageIsNotAspectRatio(image)) {
      image.style.width = width;
    } else {
      image.style.width = '100%';
    }
  },

  _imageIsNotAspectRatio : function (image) {
    return this._roundToTwoDecimals(image.naturalHeight / image.naturalWidth) !== this._roundToTwoDecimals(widthAspectRatio);
  },

  _roundToTwoDecimals : function (num) {
    return Math.round(num * 100) / 100;
  },

  _adjustImageContainerHeight : function () {
    if (!this.refs.imageContainer) return;

    var imageContainer = ReactDOM.findDOMNode(this.refs.imageContainer);
    var outerWidth = $(imageContainer).outerWidth();
    imageContainer.style.lineHeight = imageContainer.style.height =  Math.round(widthAspectRatio * outerWidth) + "px";
  },

  _addWindowResizeEvent : function(){
    $(window).resize(this._adjustImageContainerHeight);
  },

  _removeWindowResizeEvent: function(){
    $(window).off("resize", this._adjustImageContainerHeight);
  }

});

module.exports = ChallengeCardImage;



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/challenge_card_image.jsx